var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useId } from '../hooks';
import { Text } from '../text';
import Checkmark from './checkmark';
import { inputStaticStyle, labelStaticStyle, wrapperStyle } from './styles';
function CheckboxInternal(_a, ref) {
    var ariaLabel = _a["aria-label"], checked = _a.checked, children = _a.children, _b = _a.defaultChecked, defaultChecked = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? false : _d, _e = _a.inverted, inverted = _e === void 0 ? false : _e, _f = _a.isIndeterminate, isIndeterminate = _f === void 0 ? false : _f, _g = _a.size, size = _g === void 0 ? 'medium' : _g, restProps = __rest(_a, ['aria-label', "checked", "children", "defaultChecked", "disabled", "error", "inverted", "isIndeterminate", "size"]);
    var _h = useFocusRing(), focusProps = _h.focusProps, isFocusVisible = _h.isFocusVisible;
    var checkboxRef = useRef(null);
    var _j = __read(useState(defaultChecked), 2), internalChecked = _j[0], setInternalChecked = _j[1];
    var checkboxId = "checkbox-".concat(useId());
    var hasChildren = children != null;
    useImperativeHandle(ref, function () { return checkboxRef.current; });
    function handleChange(event) {
        setInternalChecked(event.target.checked);
    }
    // Handle setting the IDL property, as it's not available as a normal attribute
    useEffect(function () {
        if (checkboxRef.current != null) {
            checkboxRef.current.indeterminate = isIndeterminate;
        }
    }, [isIndeterminate]);
    return (_jsxs("div", __assign({ css: wrapperStyle({ disabled: disabled, inverted: inverted }) }, { children: [_jsx("input", __assign({ ref: checkboxRef }, (hasChildren && { id: checkboxId }), { "aria-invalid": error, "aria-label": ariaLabel, css: inputStaticStyle, disabled: disabled, type: "checkbox" }, mergeProps(focusProps, restProps, __assign({}, (checked == null
                ? { defaultChecked: defaultChecked, onChange: handleChange }
                : { checked: checked }))))), _jsx(Checkmark, __assign({}, {
                checked: checked !== null && checked !== void 0 ? checked : internalChecked,
                error: error,
                isFocusVisible: isFocusVisible,
                isIndeterminate: isIndeterminate,
            })), hasChildren && (_jsx(Text, __assign({ as: "label", css: labelStaticStyle, htmlFor: checkboxId, size: size }, { children: children })))] })));
}
export default CheckboxInternal;
